var _rect, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmoothnessEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Smoothness Events",
    role: "img",
    viewBox: "0 0 100 102",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smoothness Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.9993,
    y: 38.851,
    fill: "none",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1015.214 -273.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105.735,375.786h-69.4972c-1.3654,0-2.4725-1.1114-2.4725-2.4825 s1.1072-2.4825,2.4725-2.4825h69.4869c2.51-0.0001,4.5442-2.0429,4.5442-4.5628v-0.864c0-2.5207-2.0336-4.5649-4.5442-4.5678 h-81.0188c-5.2423,0-9.4919-4.2668-9.4919-9.5302c0-5.2635,4.2496-9.5302,9.4919-9.5302h11.2548 c1.3655,0,2.4725,1.1114,2.4725,2.4825s-1.1071,2.4825-2.4725,2.4825h-11.2548c-2.5112,0-4.5469,2.044-4.5469,4.5652 s2.0358,4.5652,4.5469,4.5652h81.0188c5.2384,0.0056,9.4838,4.2681,9.4893,9.5278v0.8688 c0.0054,5.2565-4.2345,9.5223-9.4698,9.5278c-0.0031,0-0.0067,0-0.0096,0L1105.735,375.786z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.927,0C33.9876,0.0027,21.0679,12.9769,21.0679,28.9805 c0,15.6247,26.1741,37.5946,27.2866,38.5181c0.9151,0.7611,2.2395,0.7611,3.1546,0c1.1173-0.9235,27.2863-22.8984,27.2863-38.5181 l0,0C78.7761,12.9812,65.8618,0.0167,49.927,0z M49.927,39.5807c-5.8227,0.0027-10.545-4.7342-10.548-10.5802 c-0.0024-5.846,4.715-10.5875,10.5377-10.5904c5.8227-0.0027,10.545,4.7342,10.548,10.5802c0,0.0033,0,0.0067,0,0.01 C60.4647,34.8436,55.7466,39.5807,49.927,39.5807z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothnessEvents);
export default __webpack_public_path__ + "static/media/smoothness-events.68b4ba43bee6f5b77c5bd6c617901a0b.svg";
export { ForwardRef as ReactComponent };